import React from 'react';
import { observer } from 'mobx-react';
import './index.less';

interface ResourceHideListWrapProps {
    isHideSearch: boolean,
    loading: boolean,
    handleSearchHide:any
}

@observer
class ResourceHideListWrap extends React.Component<ResourceHideListWrapProps, any> {

    searchHide = (bool) => {
        const { handleSearchHide } = this.props;
        handleSearchHide && handleSearchHide(bool)
    }

    render() {
        const { isHideSearch, loading } = this.props;
        return (
            <div className="resource-hide-list-wrap">
                { !loading && (!isHideSearch ? <div className="search-hide" onClick={() => this.searchHide(true)} />
                    : <div className="search-show" onClick={() => this.searchHide(false)} />)
                }
                <div style={{ 'display': isHideSearch ? 'none' : 'block', boxShadow: '0 -1px 0 0 #e2e2e2' }}>
                    {this.props.children}
                </div>
            </div>
        )
    }

}

export default ResourceHideListWrap;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/view-resource/ResourceHideListWrap/index.tsx